import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.parse-int.js";
var time = {
  formatOnSaleTime: function formatOnSaleTime(onSaleTime) {
    var dateToWeek = {
      0: '周日',
      1: '周一',
      2: '周二',
      3: '周三',
      4: '周四',
      5: '周五',
      6: '周六'
    };
    var saleDate = new Date(Number(onSaleTime));
    var saleMonth = saleDate.getMonth() + 1;
    var saleDay = saleDate.getDate();
    var saleHour = saleDate.getHours();
    var saleMinute = saleDate.getMinutes();
    var saleSeconds = saleDate.getSeconds();
    var weekDay = saleDate.getDay();
    var yearText = saleDate.getFullYear();
    var monthText = saleMonth;
    var dayText = saleDay;
    var formatMonthText = saleMonth < 10 ? '0' + saleMonth : saleMonth;
    var formatDayText = saleDay < 10 ? '0' + saleDay : saleDay;
    var hourText = saleHour > 9 ? saleHour : '0' + saleHour;
    var minuteText = saleMinute > 9 ? saleMinute : '0' + saleMinute;
    var secondText = saleSeconds > 9 ? saleSeconds : '0' + saleSeconds;
    var timeText = "".concat(monthText, "\u6708").concat(dayText, "\u65E5 ").concat(hourText, ":").concat(minuteText, ":").concat(secondText);
    var weekDayText = dateToWeek[weekDay];
    return {
      onSaleTime: timeText,
      onSaleTimeInfo: {
        yearText: yearText,
        monthText: monthText,
        dayText: dayText,
        hourText: hourText,
        minuteText: minuteText,
        secondText: secondText,
        weekDayText: weekDayText,
        formatMonthText: formatMonthText,
        formatDayText: formatDayText
      }
    };
  },
  fomatRemainText: function fomatRemainText(now, onSaleTime) {
    // 无论mistiming大于零小于零都应该计算
    var exactCurrentTime = now;
    var timeDistance = onSaleTime - exactCurrentTime;
    // 计算剩余天差
    // const leftDays = this.calculateLeftDays(onSaleTime, exactCurrentTime)
    var leftTimeInfo = this.fomatLeftTime(timeDistance);
    return leftTimeInfo;
  },
  fomatLeftTime: function fomatLeftTime(leftTimeStamp) {
    var allHours = leftTimeStamp / 1000 / 60 / 60;
    // 由于时间差的天数和实际天数有区别
    // eg. 11-02 23:00 到 11-04 00:00相差25小时，计算出天数差为1天，现实理解为2天
    // eg. 11-02 20:00 到 11-04 22:00相差50小时，计算出天数差为2天，现实理解为2天
    // eg. 11-02 20:00 到 11-04 18:00相差46小时，计算出天数差为1天，现实理解为2天
    // eg. 11-02 20:00 到 11-03 22:00相差26小时，计算出天数差为1天，现实理解为1天
    var leftDays = this._pad(parseInt(leftTimeStamp / 1000 / 60 / 60 / 24, 10));
    // const leftDays = parseInt(leftTimeStamp / 1000 / 60 / 60 / 24, 10)
    var leftHours = this._pad(parseInt(leftTimeStamp / 1000 / 60 / 60 % 24, 10));
    var leftMinutes = this._pad(parseInt(leftTimeStamp / 1000 / 60 % 60, 10));
    var leftSeconds = this._pad(parseInt(leftTimeStamp / 1000 % 60, 10));
    return {
      allHours: allHours,
      leftDays: leftDays,
      leftHours: leftHours,
      leftMinutes: leftMinutes,
      leftSeconds: leftSeconds
    };
  },
  getLeftDays: function getLeftDays(leftTimeStamp) {
    return parseInt(leftTimeStamp / 1000 / 60 / 60 / 24, 10);
  },
  getLeftHours: function getLeftHours(leftTimeStamp) {
    return parseInt(leftTimeStamp / 1000 / 60 / 60 % 24, 10);
  },
  getLeftMinutes: function getLeftMinutes(leftTimeStamp) {
    return parseInt(leftTimeStamp / 1000 / 60 % 60, 10);
  },
  getLeftSeconds: function getLeftSeconds(leftTimeStamp) {
    return parseInt(leftTimeStamp / 1000 % 60, 10);
  },
  // 语意化上的天数差距计算方法
  // calculateLeftDays(onSaleTime, currentTime) {
  //   // 根据日期零点计算天数差
  //   const strSaleDate = util.formatDate(new Date(onSaleTime), 'yyyy/MM/dd')
  //   const strCurrentDate = util.formatDate(new Date(currentTime), 'yyyy/MM/dd')
  //   const leftDays = (Date.parse(strSaleDate) - Date.parse(strCurrentDate)) / (1000 * 60 * 60 * 24)
  //   return leftDays
  // },
  _pad: function _pad(val) {
    val = +val;
    return val < 10 && val >= 0 ? "0".concat(val) : val;
  }
};
export default time;